import React from 'react';

import { Card, CardBody, CardHeader, Image, Separator, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/core/react/router';

import { useUsefulArticlesSection } from './hooks/useUsefulArticlesSection';

export const UsefulArticlesSection: React.FC = () => {
	const {
		data: { coreArticles },
		actions: { trackArticleClick },
	} = useUsefulArticlesSection();

	return (
		<div className="hidden md:block">
			<Separator className="border-stroke-weaker" />

			<div className="container mt-6 mb-10 space-y-4 md:my-[60px]">
				<Text size="small" variant="heading" fontWeight="light">
					<Translate value="corgi.petition_guides_article.page_body.footer.useful_articles_section.title" />:
				</Text>

				<div className="grid grid-cols-1 place-items-center gap-6 md:grid-cols-3">
					{coreArticles.map((article) => (
						<Card
							key={article.slug}
							as={Link}
							data-qa={`${article.slug}-footer-link`}
							aria-label={article.heading ?? undefined}
							to={`/petition-guides/${encodeURIComponent(article.slug)}?source_location=${article.slug}-article`}
							className="h-full max-w-[392px] no-underline"
							onClick={trackArticleClick}
						>
							<CardHeader variant="media">
								<Image src={article.heroImage?.url} alt={article.heroImage?.title} className="object-cover" />
							</CardHeader>
							<CardBody className="flex flex-col px-6">
								<Text variant="heading" size="small">
									{article.headingShort}
								</Text>

								<Text>{article.subheadingShort}</Text>
							</CardBody>
						</Card>
					))}
				</div>
			</div>
		</div>
	);
};
